// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"button_wrapper__3Jb9w","filled":"button_filled__1f8KA","primary":"button_primary__2gxzS","disabled":"button_disabled__1KDkh","link":"button_link__3VqdI"};